/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './NoAccountsPage.scss'
import React from 'react';
import Content from 'services/Content';
import { contentConverter } from 'services/Content';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { footerLinks, deComLoginUrl } from 'services/Externals';
import { ak529DecomEnabled } from 'services/FeatureFlags';
import { NON_BREAKING_SPACE } from 'services/Formats';

const convertedContent = contentConverter.makeHtml(
  Content.noAccountsDetailMessage
);
const convertedNATContent = contentConverter.makeHtml(
  Content.noAccountsNATDetailMessage
);

const NoAccountsPage = () => (
  <div className="no-accounts-error-container">
    <WarningIcon className="no-accounts-icon" />
    {
       ak529DecomEnabled() ? (<div className="no-accounts-error-title">
        529 College Savings Plan accounts have moved to a new online platform.
      </div>) :
        (<div className="no-accounts-error-title">
          The following 529 college savings plan accounts have moved to a new online platform.
        </div>)

    }

    {!ak529DecomEnabled() && <div className="no-accounts-error-content md529">
      <p>
        For <b>T. Rowe Price College Savings Plan accounts</b>, to reestablish online access on or after May 13, 2024, visit
        {NON_BREAKING_SPACE}
        <a href="https://troweprice529.com/" className="no-accounts-contact-us-link">troweprice529.com</a>
        {NON_BREAKING_SPACE}
        and log in to create a new username and password. Review this
        {NON_BREAKING_SPACE}
        <a href={footerLinks.nat529DecomUrl} className="no-accounts-contact-us-link">T. Rowe Price College Savings Plan Transition Guide</a>
        {NON_BREAKING_SPACE}
        for more information.
      </p>
      <p>
        For <b>Maryland College Investment Plan accounts</b>, to reestablish online access, visit
        {NON_BREAKING_SPACE}
        <a href="https://Maryland529.com/" className="no-accounts-contact-us-link">Maryland529.com</a>
        {NON_BREAKING_SPACE}
        and log in to create a new username and password.
      </p>
    </div>}
    {ak529DecomEnabled() && <div className="no-accounts-error-content md529">
      <p>
        For <b>Alaska 529 accounts</b>, to reestablish online access on or after July 29, 2024, visit
        {NON_BREAKING_SPACE}
        <a href="https://alaska529plan.com/" className="no-accounts-contact-us-link">alaska529plan.com</a>
        {NON_BREAKING_SPACE}
        and log in to create a new username and password. Review this
        {NON_BREAKING_SPACE}
        <a href={footerLinks.ak529DecomUrl} className="no-accounts-contact-us-link">Alaska 529 Transition Guide</a>
        {NON_BREAKING_SPACE}
        for more information.
      </p>
      <p>
        For <b>T. Rowe Price College Savings Plan accounts</b>, to reestablish online access, visit
        {NON_BREAKING_SPACE}
        <a href="https://troweprice529.com/" className="no-accounts-contact-us-link">troweprice529.com</a>
        {NON_BREAKING_SPACE}
        and log in to create a new username and password.
      </p>
      <p>
        For <b>Maryland College Investment Plan accounts</b>, to reestablish online access, visit
        {NON_BREAKING_SPACE}
        <a href="https://Maryland529.com/" className="no-accounts-contact-us-link">Maryland529.com</a>
        {NON_BREAKING_SPACE}
        and log in to create a new username and password.
      </p>
    </div>}
    {
      ak529DecomEnabled() ? (<div className="no-accounts-error-content">
        <span dangerouslySetInnerHTML={{ __html: convertedNATContent }} />
      </div>) :
        (<div className="no-accounts-error-content">
          <span dangerouslySetInnerHTML={{ __html: convertedContent }} />
        </div>)
    }
    <span>
      <a href={deComLoginUrl()} className="return-to-login-link">Return to Login</a>
    </span>
  </div>
);

export default NoAccountsPage;
